import { Link } from "react-router-dom";
import type { Episode } from "@/mocks/episodes";

export default function EpisodeCard({ episode, index = 0 }: { episode: Episode; index?: number }) {
  return (
    <Link
      to={`/episode/${episode.id}`}
      className="group block rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 45}ms` }}
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={episode.cover}
          alt={`第${episode.number}集 ${episode.title} 剧情封面`}
          title={`甜蜜惩罚 第${episode.number}集 ${episode.title}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-label">
          第 {episode.number} 集
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-label">
          {episode.duration}
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base text-foreground-950 mb-2 group-hover:text-primary-700 transition-colors line-clamp-1">
          {episode.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 font-label">{episode.summary}</p>
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 flex-wrap">
            {episode.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-[11px] font-label"
              >
                {tag}
              </span>
            ))}
          </div>
          <span className="text-xs text-foreground-400 font-label whitespace-nowrap">{episode.releaseDate}</span>
        </div>
      </div>
    </Link>
  );
}